exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reduction{border-bottom:1px solid #d5dde2;margin-bottom:50px;padding-bottom:50px\n}\n@media (min-width:700px){\n.reduction{display:grid;grid-gap:20px\n}\n.reduction p,.reduction p input,.reduction p select{margin:0\n}\n.reduction__grid{display:grid;grid-gap:30px\n}\n.reduction__grid--three{grid-template-columns:repeat(3,1fr)\n}\n.reduction__grid--four{grid-template-columns:repeat(5,1fr)\n}\n}", ""]);

// exports
